import {  Image, Space, Typography } from "antd"

import { InsurancePolicyNotFound } from "../../../../../assets"

import './index.css'

export const PolicyNotFound = () => {
    return (
            <Space className="container-policy-not-found" >
                <Image 
                    src={ InsurancePolicyNotFound } 
                    width={184} 
                    height={152} 
                    preview={false}
                />
                <Typography.Text type="secondary" style={{ fontSize: 18 }}>
                    No se encontraron resultados
                </Typography.Text>
            </Space>

    )
}
